import { EnrollRoute } from "../routes";
import { useEnrollment } from "./context";

export function useIsAfterRate(): boolean {
  const { nav } = useEnrollment();
  return nav.stack.slice(0, nav.cursor).includes(EnrollRoute.ConfirmRate);
}
